const A = (e) => {
  window.globalAnalyticsData = e;
}, E = (e) => {
  var n;
  (n = window == null ? void 0 : window.utag) != null && n.link ? e ? window.utag.link(e) : console.warn("No data passed to sendAnalyticsEvent") : console.warn("window.utag.link is undefined");
}, p = (e) => {
  var n;
  (n = window == null ? void 0 : window.utag) != null && n.view ? e ? window.utag.view(e) : console.warn("No data passed to sendAnalyticsPageView") : console.warn("window.utag.view is undefined");
}, L = (e, n, t) => {
  if (!e || !n || !t) {
    console.warn("name, type, or tags was not passed to the sendGA4Event helper");
    return;
  }
  window != null && window.gtag ? gtag(e, n, t) : console.warn("window.gtag is undefined");
}, _ = (e) => {
  window != null && window._ga_universal ? window._ga_universal.push(["track_event", ...e]) : console.warn("window._ga_universal is undefined");
}, u = (e) => {
  if (typeof e != "string" && !(e instanceof String))
    return e;
  const n = [
    "®",
    "™",
    "℠",
    "°"
  ], t = {
    ē: "e",
    í: "i",
    ü: "u",
    ū: "u"
  };
  let a = e;
  return n.forEach((i) => {
    a = a.replace(new RegExp(i, "g"), "");
  }), Object.keys(t).forEach((i) => {
    a = a.replaceAll(i, t[i]);
  }), a;
};
let s, w;
const r = [], o = Object.freeze({
  VIEW: "view",
  LINK: "link"
}), g = {
  [o.VIEW]: {},
  [o.LINK]: {}
}, l = () => {
  var e, n, t;
  return !!((e = window.utag) != null && e.view) && !!((n = window.utag) != null && n.link) && !!((t = window.utag_data) != null && t.GA4_ID);
}, f = () => {
  var n, t;
  if (s)
    return s;
  const e = w ?? "www.garmin.com";
  return ((n = window == null ? void 0 : window.location) == null ? void 0 : n.host) === e ? ["config", (t = window == null ? void 0 : window.utag_data) == null ? void 0 : t.GA4_ID] : [
    "config",
    "G-K5X2MQK80V",
    { debug_mode: !0 }
  ];
}, d = () => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push(["js", /* @__PURE__ */ new Date()]), window.dataLayer.push(f());
}, y = () => {
  r.forEach((e) => {
    window.utag[e.utagAnalyticsType](e.sanitizedPayload);
  });
}, v = (e) => Object.keys(e).reduce((t, a) => {
  const i = e[a];
  return Object.defineProperty(t, a, {
    value: u(i),
    enumerable: !0
  }), t;
}, {}), c = (e, n) => {
  const t = v({
    ...g[n],
    ...e
  });
  l() ? window.utag[n](t) : r.push({ utagAnalyticsType: n, sanitizedPayload: t });
}, h = (e) => {
  const { dataLayer: n, host: t } = e ?? { dataLayer: void 0, host: void 0 };
  s = n, w = t, l() ? d() : window.addEventListener("utag-ready", () => {
    d(), y();
  });
}, I = {
  /**
   * @description Checks the bindings and either fires a page view event
   * or applies a click event listener to fire when the user clicks.
   * Called when the bound element's parent component and all its children are mounted.
   * @param {Element} element The HTML element with the v-utag-event attribute
   * @param {object} binding The object passed to the v-utag-event directive
   */
  mounted: (e, n) => {
    const { value: t } = n ?? { value: {} };
    (t == null ? void 0 : t.event_action) === "click" && (e != null && e.addEventListener) ? e.addEventListener("click", () => c(t, o.LINK)) : c(t, o.VIEW);
  }
}, k = "utag-event", D = (e) => {
  window.WCS_ANALYTICS_OVERRIDES = {
    ...e
  };
};
export {
  o as UtagAnalyticsType,
  l as checkIsUtagReady,
  f as getDataLayerConfig,
  v as getSanitizedAnalyticsPayload,
  h as initializeGA4,
  d as initializeGADataLayer,
  y as processEventQueue,
  u as sanitizeAnalyticsString,
  E as sendAnalyticsEvent,
  p as sendAnalyticsPageView,
  c as sendAnalyticsPayload,
  _ as sendGA3Event,
  L as sendGA4Event,
  A as setGlobalAnalyticsData,
  D as setWcsOverrides,
  g as utagAnalyticsBaseAttributes,
  I as utagDirective,
  k as utagDirectiveName
};
